import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { SearchPageReadyToLoadSearch, SearchPageSwitchRequestedEvent, SearchType } from '@studyportals/search-page-interface';

export class ScholarshipSearchLoader implements ISubscriber<SearchPageReadyToLoadSearch> {

	private loaded = false;

	public async initialize(): Promise<void> {
		if (this.isScholarshipSearchUrl() || this.isScholarshipSearchStandalone()) {
			await this.load();
			return;
		}

		window.EventAggregationService?.subscribeTo(SearchPageReadyToLoadSearch.EventType, this, true);
	}

	public async notify(event: SearchPageReadyToLoadSearch): Promise<void>
	{
		if (event.searchType === SearchType.SCHOLARSHIP) {
			await this.load(event);
		}
	}

	private async load(event?: SearchPageReadyToLoadSearch): Promise<void> {
		if (this.loaded) return;

		await import('./main');

		this.loaded = true;

		if (event?.onSwitchSearchType) {
			window.EventAggregationService?.publishTo(SearchPageSwitchRequestedEvent.EventType, new SearchPageSwitchRequestedEvent(SearchType.SCHOLARSHIP));
		}
	}

	private isScholarshipSearchUrl(): boolean {
		return window.location.href.includes('search/scholarships');
	}

	private isScholarshipSearchStandalone(): boolean {
		const allowed = 'scholarships-search.prtl.co';
		try {
			const url = new URL(window.location.href);
			return url.host === allowed;
		}
		catch {
			return false;
		}
	}
}

const loader = new ScholarshipSearchLoader();
await loader.initialize();
